import { DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTrailerRevenueReport extends Layout {
    excludabletextboxFleetId: ExcludableTextbox;
    excludabletextboxSteamshipLine: ExcludableTextbox;
    excludabletextboxT: ExcludableTextbox;
    sourceTrailerReport: DataSource;
    switchFuelCharges: Switch;
    switchRemainingCharges: Switch;
    switchReportType: Switch;
    textboxDateRange: Textbox;
    textboxDateType: Textbox;
    textboxInclude: Textbox;
}
